module.exports = __webpack_public_path__ + "static/media/admAZZ.6f6f5490.svg";